import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styles from "./Footer.module.css";
import instagram from "../images/instagram.png";
import whatsapp from "../images/whatsapp.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot, faEnvelope, faPhone
} from "@fortawesome/free-solid-svg-icons";
import { faTiktok, faInstagram, faSnapchat
  } from "@fortawesome/free-brands-svg-icons";

const ForMen = () => {
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate("/shoesProductsForMen");
  };
  const handleOnClick2 = () => {
    navigate("/walletsProductsForMen");
  };
  const handleOnClick3 = () => {
    navigate("/clothesproductsformen");
  };
  const handleOnClick4 = () => {
    navigate("/jewelleryformen");
  };
  const handleOnClick5 = () => {
    navigate("/glassesformen");
  };
  const handleOnClick6 = () => {
    navigate("/perfumesformen");
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.item} onClick={handleOnClick}>
          <h3>Shoes</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick2}>
          <h3>Wallets</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick2}>
          <h3>Wallets</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick3}>
          <h3>Clothes</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick4}>
          <h3>Jewellery</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick5}>
          <h3>Glasses</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick6}>
          <h3>Perfumes</h3>
        </div>
      </div>
    </>
  );
};

const ForWomen = () => {
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate("/shoesProductsForWomen");
  };
  const handleOnClick2 = () => {
    navigate("/walletsProductsForWomen");
  };
  const handleOnClick3 = () => {
    navigate("/clothesproductsforwomen");
  };
  const handleOnClick4 = () => {
    navigate("/jewelleryforwomen");
  };
  const handleOnClick5 = () => {
    navigate("/glassesforwomen");
  };
  const handleOnClick6 = () => {
    navigate("/perfumesforwomen");
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.item} onClick={handleOnClick}>
          <h3>Shoes</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick2}>
          <h3>Wallets</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick3}>
          <h3>Clothes</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick4}>
          <h3>Jewellery</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick5}>
          <h3>Glasses</h3>
        </div>
        <div className={styles.item} onClick={handleOnClick6}>
          <h3>Perfumes</h3>
        </div>
      </div>
    </>
  );
};

export function Footer() {
  return (
    <>
      <footer className={styles.footer_container}>
        <div className={styles.footer_item}>
          <div>
          <b>Feel free to follow us on our social media channels.</b>
          <hr />
          <div className={styles.footer_item}>
            <Link className={styles.item} to="https://www.tiktok.com/@designerhausau?_t=8mCeVf88QBW&_r=1" >
              <FontAwesomeIcon
                icon={faTiktok}
                style={{ width: "24px", height: "24px" }}
              />{" "}
              <h3>Tiktok</h3>
            </Link>
            <Link className={styles.item} to="https://www.instagram.com/designerhaus_auu?igsh=M2dlZTl3MG5rNDZr&utm_source=qr" >
              <FontAwesomeIcon
                icon={faInstagram}
                style={{ width: "24px", height: "24px" }}
              />{" "}
              <h3>Instagram</h3>
            </Link>
            <Link className={styles.item} to="https://www.snapchat.com/add/designerhaus_au?share_id=Z6BWyU7jS8-3YLCe27jtBQ&locale=en_AU" >
              <FontAwesomeIcon
                icon={faSnapchat}
                style={{ width: "24px", height: "24px" }}
              />{" "}
              <h3>Snapchat</h3>
            </Link>
            </div>
          </div>
        </div>
        <div className={`${styles.footer_item} ${styles.footer_item_end}`}>
          <b className="copy">&copy; {new Date().getFullYear()} DESIGNER HAUS</b>
        </div>
      </footer>
    </>
  );
}


